/**
 * Referência geográfica do colégio (backend /school-location/*): usada pelo
 * admin para cadastrar lat/long/raio e pelas listas para explicar o selo
 * "fora do raio" do ponto batido pelo app.
 */
import api from './api';

export async function getSchoolLocationConfig() {
  const response = await api.get('/school-location/config');
  return response.data;
}

export async function updateSchoolLocationConfig(partial) {
  const response = await api.patch('/school-location/config', partial);
  return response.data;
}
